import { CSSProperties, forwardRef } from 'react';
import { SxProps } from '@mui/system';
import { Box, Input, Typography } from '@mui/material';
import { InputProps } from '@mui/material/Input/Input';
import { fontColorDarkTheme } from '../../styles/global.styles';

interface InputComponentProps extends InputProps {
  error?: boolean;
  success?: boolean;
  size?: 'small' | 'medium';
  color?: 'primary' | 'secondary' | 'error' | 'success' | 'info' | 'warning';
  className?: string;
  style?: CSSProperties;
  fullWidth?: boolean;
  sx?: SxProps;
  label?: string;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  min?: number;
  max?: any;
}
const InputComponent = forwardRef<HTMLInputElement, InputComponentProps>(
  (
    {
      error = false,
      success = false,
      disabled = false,
      size = 'medium',
      color = 'primary',
      fullWidth = false,
      sx = {},
      label = '',
      value = '',
      onChange,
      ...rest
    },
    ref,
  ) => {
    return (
      <Box>
        <Typography sx={{ color: fontColorDarkTheme }} fontWeight={'bold'}>
          {label}
        </Typography>
        <Input {...rest} sx={{ width: '100%', color: fontColorDarkTheme }} />
      </Box>
    );
  },
);

InputComponent.displayName = 'InputComponent';

export default InputComponent;
